/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Nav_TeamInputs */

const cs_public_site_nav_team = /** @type {(inputs: Public_Site_Nav_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Náš tým`)
};

const en_public_site_nav_team = /** @type {(inputs: Public_Site_Nav_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our team`)
};

/**
* | output |
* | --- |
* | "Our team" |
*
* @param {Public_Site_Nav_TeamInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_nav_team = /** @type {((inputs?: Public_Site_Nav_TeamInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Nav_TeamInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_nav_team(inputs)
	return cs_public_site_nav_team(inputs)
});